import { useRef, useContext } from "react";
import { ApartmentViewContext } from "../context/ApartmentViewContext";
import styles from "../../../styles/aprt.module.scss";

function InsolationController({ apartmentData }) {
	const { insolationAngle, setInsolationAngle } =
		useContext(ApartmentViewContext);
	const intervalRef = useRef(null);
	const angleIncrementValue = 2.5;
	const angle = insolationAngle;

	const sumSunLightRanges = (arr) => {
		if (!arr || arr.length === 0) return 0;
		let sum = 0;
		arr.forEach((range) => {
			sum += range[1] - range[0];
		});
    return sum;
	};

	const insolationInCompartments = apartmentData.compartments.map(
		(compartment) => {
			if (!compartment.window_area || compartment.window_area === 0) {
				return null;
			}
			if (!compartment.sun_light_ranges || compartment.sun_light_ranges.length === 0) {
				return 0;
			}
			return Math.floor(sumSunLightRanges(compartment.sun_light_ranges));
		}
	);

  const convertAngleToTime = (angle) => {
    const totalMinutes = ((angle - 90) / 180) * (12 * 60);
    const hours = Math.floor(totalMinutes / 60) + 6;
    const minutes = Math.floor(totalMinutes % 60);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const handleRotateClockwise = () => {
    setInsolationAngle((prevAngle) => {
      const newAngle = Math.min(prevAngle + angleIncrementValue, 270);
      return Math.round(newAngle / 2.5) * 2.5;
    });
  };

  const handleRotateCounterClockwise = () => {
    setInsolationAngle((prevAngle) => {
      const newAngle = Math.max(prevAngle - angleIncrementValue, 90);
      return Math.round(newAngle / 2.5) * 2.5;
    });
  };

  const startIncrement = (incrementFunction) => {
    incrementFunction();
    intervalRef.current = setInterval(incrementFunction, 100);
  };

  const stopIncrement = () => {
    clearInterval(intervalRef.current);
  };

  const handleSliderChange = (e) => {
    setInsolationAngle(parseInt(e.target.value, 10));
  };

  return (
    <div className={styles.insolation__wrapper}>
      <div className={styles.insolation__controller}>
        <div className={styles.insolation__container}>
          <button
            className={`${styles.planButton} ${styles.insolation__button}`}
            onMouseDown={() => startIncrement(handleRotateCounterClockwise)}
            onMouseUp={stopIncrement}
            onMouseLeave={stopIncrement}
          >
            -10 min
          </button>
          <div className={styles.time__current}>
            {convertAngleToTime(angle)}
          </div>
          <button
            className={`${styles.planButton} ${styles.insolation__button}`}
            onMouseDown={() => startIncrement(handleRotateClockwise)}
            onMouseUp={stopIncrement}
            onMouseLeave={stopIncrement}
          >
            +10 min
          </button>
        </div>
        <div className={styles.insolation__container}>
          <span
            className={styles.time__range}
            onClick={() => setInsolationAngle(90)}
          >
            06:00
          </span>
          <input
            className={styles.list__slider}
            type="range"
            min="90"
            max="270"
            value={angle}
            onChange={handleSliderChange}
          />
          <span
            className={styles.time__range}
            onClick={() => setInsolationAngle(270)}
          >
            18:00
          </span>
        </div>
      </div>
      <div>
        <h4>legenda kolorów:</h4>
        <div className={styles.insolation__legendRow}>
          {Object.entries(insolationFillColors).map(([key, value]) => {//TODO: use color fills form context form styles.json
            const legendKey = key === "10" ? `${key}h` : `${key}h+`;
            const legendKeyStyle = insolationInCompartments.includes(+key)
              ? styles.insolation__legendBold
              : styles.insolation__legendLabel;
            return (
              <div key={key} className={styles.insolation__legendItem}>
                <div
                  className={styles.insolation__color}
                  style={{ backgroundColor: value }}
                />
                <div className={legendKeyStyle}>{legendKey}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default InsolationController;
//TODO: Move the following to styles.json
export const insolationFillColors = {
  0: "#b0c4ef",
  1: "#b4a7e1",
  2: "#bf9dd9",
  3: "#e8a6a6",
  4: "#e8a6b1",
  5: "#f6a6a9",
  6: "#ffb0a6",
  7: "#ffc3a6",
  8: "#ffd5a6",
  9: "#ffe8a6",
  10: "#ffffae",
};
